export enum LoyaltyStatusEnum {
    All = 0,
    Active = 1,
    Upcoming = 2,
    Draft = 3,
    Disabled = 4,
    Ended = 5,
}
